
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1609845856879",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1339",
    "data-darkreader-inline-fill": "",
    "width": "64",
    "height": "64"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M394.88 403.712m46.4 0l175.936 0q46.4 0 46.4 46.4l0 0q0 46.4-46.4 46.4l-175.936 0q-46.4 0-46.4-46.4l0 0q0-46.4 46.4-46.4Z",
        "p-id": "1340",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M394.88 563.264m46.4 0l175.936 0q46.4 0 46.4 46.4l0 0q0 46.4-46.4 46.4l-175.936 0q-46.4 0-46.4-46.4l0 0q0-46.4 46.4-46.4Z",
        "p-id": "1341",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M869.504 281.92v128a175.488 175.488 0 0 0-26.816 38.4 176 176 0 0 0-19.584 80.64 176.128 176.128 0 0 0 19.584 80.64 177.024 177.024 0 0 0 26.816 38.4v129.152H188.864V648a176.448 176.448 0 0 0 26.816-38.4 176.128 176.128 0 0 0 19.584-80.64 176 176 0 0 0-19.584-80.64 174.976 174.976 0 0 0-26.816-38.4v-128h680.64M931.392 189.12H127.04A30.976 30.976 0 0 0 96.128 220.032v217.6a30.848 30.848 0 0 0 12.8 24.896 82.432 82.432 0 0 1 33.792 66.688A82.432 82.432 0 0 1 108.928 595.904a30.976 30.976 0 0 0-12.8 24.96v218.24a30.912 30.912 0 0 0 30.912 30.912h804.352a30.912 30.912 0 0 0 30.912-30.912v-218.24a30.976 30.976 0 0 0-12.8-24.96 82.496 82.496 0 0 1-33.792-66.688 82.496 82.496 0 0 1 33.792-66.688 30.848 30.848 0 0 0 12.8-24.896v-217.6A30.976 30.976 0 0 0 931.392 189.12z",
        "p-id": "1342",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    }
  ]
})
    }
  